<app-navigation-header title="Code Gen Report" i18n-title="@@codeGenReport-title">
	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		[rowId]="rowId"
		defaultPresentationMode="table"
		[appBreadcrumbLabel]="breadcrumbLabel"
		firstColumnProperty="deviceSerialNumber"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						svgIcon="sl-filter"
						label="Refine Filters"
						i18n-label="@@codeGenReport-refineFilter"
						(click)="onRefineFiltersClicked()"
						data-automation-id="code-gen-report-refine-filter-button"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						svgIcon="sl-download"
						label="Download"
						i18n-label="@@codeGenReport-download"
						(click)="onDownloadClicked()"
						data-automation-id="code-gen-report-download-button"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-table-view>
				@if (
					loadingService.isLoading(generateCodeGenReportLoadingKey) ||
					loadingService.isLoading(generateCodeGenReportCsvLoadingKey) ||
					!finishedLoadingInitData
				) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSortActive="dateValidUtcStart"
					matSortDirection="desc"
					matSort
					[hidden]="
						loadingService.isLoading(generateCodeGenReportLoadingKey) ||
						loadingService.isLoading(generateCodeGenReportCsvLoadingKey) ||
						!finishedLoadingInitData
					"
				>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
							No records found.
						</td>
					</tr>

					@if (isHaspCodeGenFeatureEnabled) {
						<ng-container matColumnDef="codeTypeId">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-codeTypeId">Type</th>
							<td mat-cell *matCellDef="let row">
								<div class="flex-row-center-div">
									<mat-icon
										class="capabilities-icon"
										svgIcon="{{ row.codeTypeId === '1' ? 'sl-access-code-gen' : 'sl-hasp-code-gen' }}"
										matTooltip="{{ row.codeTypeId === '1' ? 'Access Code' : 'Hasp Code' }}"
									>
									</mat-icon>
								</div>
							</td>
						</ng-container>
					}

					<ng-container matColumnDef="serialNumber">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-serialNumber">Serial Number</th>
						<td mat-cell *matCellDef="let row">{{ row.serialNumber }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceOwner">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-deviceOwner">Device Owner</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceOwnerName }}</td>
					</ng-container>

					<ng-container matColumnDef="generatedBy">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-generatedBy">Generated By</th>
						<td mat-cell *matCellDef="let row">{{ row.generatedByFirstName }} {{ row.generatedByLastName }}</td>
					</ng-container>

					<ng-container matColumnDef="assignedTo">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-assignedTo">Assigned To</th>
						<td mat-cell *matCellDef="let row">
							{{ row.assignedToFirstName }} {{ row.assignedToLastName }}, {{ row.assignedToEmail }}
						</td>
					</ng-container>

					@if (isCareCompany) {
						<ng-container matColumnDef="clientName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-client">Client</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientFirstName ?? '' }} {{ row?.clientLastName ?? '' }}</td>
						</ng-container>

						<ng-container matColumnDef="clientIdn">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyReport-clientIdn">Client IDN</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientIdn ?? '' }}</td>
						</ng-container>
					}

					<ng-container matColumnDef="propertyName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-propertyName">Property Name</th>
						<td mat-cell *matCellDef="let row">{{ row.propertyName }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceLocation">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-deviceLocation">
							Device Location
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceLocation }}</td>
					</ng-container>

					<ng-container matColumnDef="dateGenerated">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-dateGenerated">
							Date Generated
						</th>
						<td mat-cell *matCellDef="let row">
							<div
								[innerHTML]="
									row.dateGenerated
										? (row.dateGenerated
												| date: 'mediumDate' : timeZoneService.utcOffset(row.dateGenerated, row.locationTimezoneName)) +
											'<br/>' +
											(row.dateGenerated
												| date: 'shortTime' : timeZoneService.utcOffset(row.dateGenerated, row.locationTimezoneName)) +
											' ' +
											(row.locationTimezoneName | abbreviatedTimezone: row.dateGenerated)
										: '- - -'
								"
							></div>
						</td>
					</ng-container>

					<ng-container matColumnDef="dateValidUtcStart">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-dateValidStart">
							Valid Start Date
						</th>
						<td mat-cell *matCellDef="let row">
							@if (row.deviceGeneration?.toLowerCase()?.includes('gen4')) {
								<div
									[innerHTML]="
										row.dateValidUtcStart
											? (row.dateValidUtcStart
													| date
														: 'mediumDate'
														: timeZoneService.utcOffset(row.dateValidUtcStart, row.locationTimezoneName)) +
												'<br/>' +
												(row.dateValidUtcStart
													| date
														: 'shortTime'
														: timeZoneService.utcOffset(row.dateValidUtcStart, row.locationTimezoneName)) +
												' ' +
												(row.locationTimezoneName | abbreviatedTimezone: row.dateValidUtcStart)
											: '- - -'
									"
								></div>
							}
							@if (!row.deviceGeneration?.toLowerCase()?.includes('gen4')) {
								<div
									[innerHTML]="
										row.dateValidUtcStart ? (row.dateValidUtcStart | accessDate) + '<br/>' + '12:00 AM' : '- - -'
									"
								></div>
							}
						</td>
					</ng-container>

					<ng-container matColumnDef="dateValidUtcEnd">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-dateValidEnd">
							Valid End Date
						</th>
						<td mat-cell *matCellDef="let row">
							@if (row.deviceGeneration?.toLowerCase()?.includes('gen4')) {
								<div
									[innerHTML]="
										row.dateValidUtcEnd
											? (row.dateValidUtcEnd
													| date
														: 'mediumDate'
														: timeZoneService.utcOffset(row.dateValidUtcEnd, row.locationTimezoneName)) +
												'<br/>' +
												(row.dateValidUtcEnd
													| date
														: 'shortTime'
														: timeZoneService.utcOffset(row.dateValidUtcEnd, row.locationTimezoneName)) +
												' ' +
												(row.locationTimezoneName | abbreviatedTimezone: row.dateValidUtcEnd)
											: '- - -'
									"
								></div>
							}
							@if (!row.deviceGeneration?.toLowerCase()?.includes('gen4')) {
								<div [innerHTML]="'- - -'"></div>
							}
						</td>
					</ng-container>

					<ng-container matColumnDef="reason">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@codeGenReport-reason">Reason</th>
						<td mat-cell *matCellDef="let row">
							<span [title]="row.reason">{{ this.getShortenedText(row.reason, 50) }}</span>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</app-data-set-table-view>
		</app-data-set-content>
	</app-data-set>
</app-navigation-header>
